import ComponentStep from './ComponentStep';
import './ComponentStep.scss';

export default ComponentStep;
